import React, { useState } from 'react';
import { Spinner } from 'react-magma-dom';
import { CloudDownloadIcon } from 'react-magma-icons';
import { ErrorDownloadModal } from '../../Modal/ErrorDownloadModal';
import { StyledPrintPageButton } from '../../Styled/StyledButtons';
import { StyledButtonSpinnerWrapper } from '../../Styled/StyledWrappers';
import { handleDownloadFile } from '../../../utils';
import { LessonPdf } from '../../../types/lessons';

interface IDownloadDocument {
  pdf: LessonPdf;
  color: string;
}

export const DownloadDocument = (props: IDownloadDocument): JSX.Element => {
  const { pdf, color } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const openErrorModal = () => {
    setIsErrorModalOpen(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const onDownload = () => {
    !isLoading && handleDownloadFile(pdf.title, pdf.links.self, setIsLoading, openErrorModal);
  };

  if (isLoading) {
    return (
      <StyledButtonSpinnerWrapper margin="0 0 4px 0" disabled={isLoading}>
        <Spinner color={color} size={36} />
      </StyledButtonSpinnerWrapper>
    );
  }

  return (
    <>
      <StyledPrintPageButton data-testid="print-page-btn" onClick={onDownload}>
        <CloudDownloadIcon color={color} size={36} />
      </StyledPrintPageButton>
      {isErrorModalOpen && (
        <ErrorDownloadModal
          mainColor={color}
          onCloseClick={closeErrorModal}
          onRetryClick={() => {
            closeErrorModal();
            onDownload();
          }}
        />
      )}
    </>
  );
};
